module.exports = __webpack_public_path__ + "fonts/Source-Sans-Pro-Bold.1a4bcb3e.woff2";